import PropTypes    from 'prop-types';
import randomInt    from 'random-int';
import randomString from '../utils/randomString';

const userShape = {
  '@id':      PropTypes.string.isRequired,
  '@type':    PropTypes.string.isRequired,
  id:         PropTypes.string.isRequired,
  givenName:  PropTypes.string,
  familyName: PropTypes.string,
};


const userPropType = PropTypes.shape(userShape);


const generateMockUser = () => {

  const id = randomString(32);

  return {
    '@id':      '/users/' + id,
    '@type':    'http://schema.org/Person',
    id:         id,
    givenName:  randomString(randomInt(3, 10)),
    familyName: randomString(randomInt(3, 20)),
  };

};


export {
  userShape,
  userPropType,
  generateMockUser,
};


// WEBPACK FOOTER //
// ./src/domain/user.js